import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ScheduleService } from "../../../services";
import { RootState } from "../../../app";
import { setSchedules } from "../../../app/store/scheduleSlice";

export function useCalendarUserSchedules(selectedUserId: number | null) {  
  const dispatch = useDispatch();
  const scheduleService = useMemo(() => new ScheduleService(), []);
  
  // Get schedules from Redux store
  const cachedSchedules = useSelector((state: RootState) => 
    selectedUserId ? state.schedules.schedulesByUser[selectedUserId] : undefined
  );
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!selectedUserId) {
      return;
    }
    
    // If we have data in Redux, don't fetch
    if (cachedSchedules) {
      return;
    }

    // Fetch from API if not in cache
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const userSchedules = await scheduleService.getUserSchedulesAsync(selectedUserId);
        dispatch(setSchedules({ userId: selectedUserId, schedules: userSchedules }));
      } catch (err) {
        console.error("Error fetching schedules:", err);
        setError("Failed to load schedules");
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, [selectedUserId, cachedSchedules, scheduleService, dispatch]);

  return {
    schedules: cachedSchedules || [],
    isLoading,
    error,
  };
}